"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _default = {
  "lucoli": {
    "b2f453df": [{
      "hkey": "f2ba7961",
      "slug": "casavecchia-colle-piaggia",
      "name": "Casavecchia-Colle-Piaggia",
      "primary": true,
      "skipSearch": false
    }],
    "casavecchia": [{
      "hkey": "f2ba7961",
      "slug": "casavecchia-colle-piaggia",
      "name": "Casavecchia-Colle-Piaggia",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": null
    }],
    "65a085b8": [{
      "hkey": "f2ba7961",
      "slug": "casavecchia-colle-piaggia",
      "name": "Casavecchia-Colle-Piaggia",
      "primary": true,
      "skipSearch": false
    }],
    "colle": [{
      "hkey": "f2ba7961",
      "slug": "casavecchia-colle-piaggia",
      "name": "Casavecchia-Colle-Piaggia",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": "lucoli"
    }],
    "2d8f8db6": [{
      "hkey": "c6d0d514",
      "slug": "san-menna-santa-croce-francolisco-sant-andrea",
      "name": "San Menna-Santa Croce-Francolisco-Sant'Andrea",
      "primary": true,
      "skipSearch": false
    }],
    "francolisco": [{
      "hkey": "c6d0d514",
      "slug": "san-menna-santa-croce-francolisco-sant-andrea",
      "name": "San Menna-Santa Croce-Francolisco-Sant'Andrea",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": "lucoli"
    }],
    "df9a8158": [{
      "hkey": "b7ba3aef",
      "slug": "prata-peschiolo",
      "name": "Prata-Peschiolo",
      "primary": true,
      "skipSearch": false
    }],
    "peschiolo": [{
      "hkey": "b7ba3aef",
      "slug": "prata-peschiolo",
      "name": "Prata-Peschiolo",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": "lucoli"
    }],
    "3dbea9e6": [{
      "hkey": "f2ba7961",
      "slug": "casavecchia-colle-piaggia",
      "name": "Casavecchia-Colle-Piaggia",
      "primary": true,
      "skipSearch": false
    }],
    "piaggia": [{
      "hkey": "f2ba7961",
      "slug": "casavecchia-colle-piaggia",
      "name": "Casavecchia-Colle-Piaggia",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": "lucoli"
    }],
    "99a9a87a": [{
      "hkey": "b7ba3aef",
      "slug": "prata-peschiolo",
      "name": "Prata-Peschiolo",
      "primary": true,
      "skipSearch": false
    }],
    "prata": [{
      "hkey": "b7ba3aef",
      "slug": "prata-peschiolo",
      "name": "Prata-Peschiolo",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": null
    }],
    "91fa4aa3": [{
      "hkey": "c6d0d514",
      "slug": "san-menna-santa-croce-francolisco-sant-andrea",
      "name": "San Menna-Santa Croce-Francolisco-Sant'Andrea",
      "primary": true,
      "skipSearch": false
    }],
    "sant-andrea": [{
      "hkey": "c6d0d514",
      "slug": "san-menna-santa-croce-francolisco-sant-andrea",
      "name": "San Menna-Santa Croce-Francolisco-Sant'Andrea",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": "lucoli"
    }],
    "e16abef7": [{
      "hkey": "c6d0d514",
      "slug": "san-menna-santa-croce-francolisco-sant-andrea",
      "name": "San Menna-Santa Croce-Francolisco-Sant'Andrea",
      "primary": true,
      "skipSearch": false
    }],
    "santa-croce": [{
      "hkey": "c6d0d514",
      "slug": "san-menna-santa-croce-francolisco-sant-andrea",
      "name": "San Menna-Santa Croce-Francolisco-Sant'Andrea",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": "lucoli"
    }],
    "2f7c087f": [{
      "hkey": "c6d0d514",
      "slug": "san-menna-santa-croce-francolisco-sant-andrea",
      "name": "San Menna-Santa Croce-Francolisco-Sant'Andrea",
      "primary": true,
      "skipSearch": false
    }],
    "santa-menna": [{
      "hkey": "c6d0d514",
      "slug": "san-menna-santa-croce-francolisco-sant-andrea",
      "name": "San Menna-Santa Croce-Francolisco-Sant'Andrea",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": null
    }],
    "39ab0782": [{
      "hkey": "182c7bea",
      "slug": "spogna-spognetta",
      "name": "Spogna-Spognetta",
      "primary": true,
      "skipSearch": false
    }],
    "spogna": [{
      "hkey": "182c7bea",
      "slug": "spogna-spognetta",
      "name": "Spogna-Spognetta",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": null
    }],
    "762050c5": [{
      "hkey": "182c7bea",
      "slug": "spogna-spognetta",
      "name": "Spogna-Spognetta",
      "primary": true,
      "skipSearch": false
    }],
    "spognetta": [{
      "hkey": "182c7bea",
      "slug": "spogna-spognetta",
      "name": "Spogna-Spognetta",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": "lucoli"
    }]
  }
};
exports["default"] = _default;